































































import { Component, Vue, Watch } from 'vue-property-decorator';

import * as STdata from './data/data.json'
import { bus } from './main'

import AppStart from './components/AppStart.vue'
import AppNavigation from './components/AppNavigation.vue'
import AppStatement from './components/AppStatement.vue'
import AppResults from './components/AppResults.vue'
import AppFooter from './components/AppFooter.vue'

@Component({
	components: {
        AppStart,
		AppNavigation,
		AppStatement,
		AppResults,
		AppFooter
	}
})
export default class App extends Vue {
	data: any = (<any>STdata).default
	currentStatementId: number = this.$store.getters.currentStatementId
	direction: 'next' | 'previous' = 'next'

	filledInEnough(): [boolean, number] {
		const userChoices = this.$store.getters.choices
		let questionsFilled = 0

		if (userChoices.length === 0) return [false, 0]

		for (let i = 0; i < userChoices.length; i++) {
			if (userChoices[i] !== 'skip') questionsFilled++
		}

		if (questionsFilled >= (userChoices.length / 2)) return [true, questionsFilled]

		return [false, questionsFilled]
	}

	goToStatement(statementId: number): void {
		if ((statementId - 1) === this.data.statements.length) {
			this.$router.push({
				name: 'Results'
			})
		} else {
			this.$router.push({
				name: 'Statement',
				params: {
					statementId: JSON.stringify(statementId)
				}
			})
		}

	}

	statementDecide(choice: boolean | 'skip'): void {
		const recordedChoice = {id: this.$store.getters.currentStatementId, choice: choice}
		
		if (this.$store.getters.choices[this.$store.getters.currentStatementId] !== choice) {
			this.$store.dispatch('recordResultsSeen', false)
		}

		this.$store.dispatch('recordChoice', recordedChoice)

	}

	created() {
		_paq.push(['trackEvent', 'systemEvent', 'toolStarted'])

		bus.$on('goToStatement', (statementId: number) => {
			this.goToStatement(statementId)
		})
		bus.$on('changeDirection', (direction: 'next' | 'previous') => {
			this.direction = direction
		})
	}
}
